import {
  CATALOG_ROOT,
  CHART_ROOT,
  SEEK_ROOT,
  SIDEKICK_ROOT,
} from './settings';

export {
  CATALOG_ROOT,
  CHART_ROOT,
  SEEK_ROOT,
  SIDEKICK_ROOT,
};

export const ROOT = '/';
